export default __webpack_public_path__ + "static/kits-bulk-b48fec8bc42c809cf4d2729cf4bd20cf.png";